'use strict';

var _ = require('lodash');
var GridSettingsFactory = function GridSettingsFactory(GridColumn, GridColumnGroup, SortCriteria, SortColumn, gridColumnAvailabilityService) {
  var widthRegExp = /\d+\.?\d*|%/g;
  function adjustColumnsWithGivenValues(columns, measurementUnit, factor) {
    _.forEach(columns, function (element) {
      if (element.width) {
        var actualWidthUnit = element.width.toString().match(widthRegExp)[1] || '';
        var actualWithValue = parseFloat(element.width.toString().match(widthRegExp)[0]);
        element.width = actualWithValue + actualWithValue * factor + actualWidthUnit;
      } else if (element.columns) {
        adjustColumnsWithGivenValues(element.columns, measurementUnit, factor);
      } else {
        element.width = undefined;
      }
    });
  }
  function adjustColumnsWidth(columns, reducedWidth) {
    if (!_.isEmpty(reducedWidth)) {
      var remainingColumnsWidth = calculateTotalWidth(columns);
      var parsedUnit = reducedWidth[0].toString().match(widthRegExp);
      var measurementUnit = parsedUnit ? parsedUnit[1] || '' : '';
      var widthToApply = reducedWidth.reduce(function (prev, curr) {
        var currentWidth = curr.toString().match(widthRegExp);
        return prev + (+currentWidth[0] || 0);
      }, 0);
      adjustColumnsWithGivenValues(columns, measurementUnit, +widthToApply / remainingColumnsWidth);
    }
    return columns;
  }
  function filterColumnsByFeature(data, gridMode) {
    var result = [];
    var reducedWidth = [];
    _.forEach(_.cloneDeep(data.columns), function (column) {
      if (gridColumnAvailabilityService.isColumnAvailable(column, gridMode)) {
        if (column.field) {
          result.push(column);
        } else if (column.groupId) {
          var filteredCount = 0;
          column.columns = _.filter(column.columns, function (subColumn) {
            if (gridColumnAvailabilityService.isColumnAvailable(subColumn, gridMode)) {
              return true;
            } else if (subColumn.width) {
              reducedWidth.push(subColumn.width);
              subColumn.width = 0;
            }
            filteredCount++;
            return false;
          });
          if (column.columns.length > 0 || !!column.dataDrivenColumn && filteredCount === 0) {
            result.push(column);
          }
        }
      } else if (column.width) {
        reducedWidth.push(column.width);
        column.width = 0;
      }
    });

    //by default isScalable = true
    var isScalable = _.isUndefined(data.scalable) || data.scalable;
    return isScalable ? adjustColumnsWidth(result, reducedWidth) : result;
  }
  function calculateTotalWidth(columns) {
    var totalWidth = 0;
    _.forEach(columns, function (column) {
      if (column.width) {
        var currWidth = +column.width.toString().match(widthRegExp)[0] || 0;
        totalWidth += currWidth;
      } else if (column.columns) {
        totalWidth += calculateTotalWidth(column.columns);
      }
    });
    return totalWidth;
  }
  var GridSettings = function GridSettings(data, gridMode) {
    this._data = {
      gridId: _.cloneDeep(data.gridId),
      sortCriteria: _.cloneDeep(data.sortCriteria)
    };
    this.gridId = data.gridId;
    this.columns = this.transformColumns(filterColumnsByFeature(data, gridMode));
    this.visibleColumns = data.visibleColumns;
    this.sortCriteria = this.transformSorting(this.gridId, data.sortCriteria);
    this.defaultSortCriteria = this.transformSorting(this.gridId, data.sortCriteria);
    this.scalable = data.scalable;
    this.height = data.height;
    this.autoheight = _.get(data, 'autoheight', false);
    this.minrows = data.minrows;
    this.maxrows = data.maxrows;
    this.editable = !_.isUndefined(data.editable) ? data.editable : true;
    this.columnsheight = data.columnsheight;
    this.dynamicColumns = this.transformColumns(filterColumnsByFeature({
      columns: data.dynamicColumns || []
    }, gridMode));
    this.isDynamic = data.isDynamic;
    this.dynamicFields = data.dynamicFields;
  };
  GridSettings.prototype.addGroup = function (name, id) {
    var self = this;
    var modelData = {
      gridId: self.gridId,
      groupId: id,
      title: name,
      columns: []
    };
    this.columns.push(new GridColumnGroup(modelData));
  };
  GridSettings.prototype.getGroup = function (findId) {
    return _.chain(this.columns).filter({
      id: findId
    }).first().value();
  };
  GridSettings.prototype.transformColumns = function (columns) {
    return _.transform(columns, function (collection, data) {
      data.gridId = this.gridId;
      if (data instanceof GridColumnGroup || data instanceof GridColumn) {
        collection.push(data);
      } else if (data.field) {
        collection.push(new GridColumn(data));
      } else if (data.groupId) {
        collection.push(new GridColumnGroup(data));
      }
    }.bind(this));
  };
  GridSettings.prototype.transformSorting = function (gridId, sort) {
    var sortCriteria, sortColumns;
    sortColumns = _.transform(sort, function (collection, data) {
      if (data instanceof SortColumn) {
        collection.push(data);
      } else if (data.field) {
        var sortColumn = new SortColumn(data.field, data.direction);
        sortColumn.setFieldAlias(data.fieldAlias);
        collection.push(sortColumn);
      }
    });
    sortCriteria = new SortCriteria(sortColumns);
    sortCriteria.setIsCustomSort(true);
    return sortCriteria;
  };
  GridSettings.prototype.toMergeFormat = function () {
    return {
      gridId: this._data.gridId,
      sortCriteria: this._data.sortCriteria,
      columns: _.transform(this.columns, function (result, column) {
        return result.push(column.toMergeFormat());
      })
    };
  };
  GridSettings.prototype.toExportFormat = function () {
    return {
      gridId: this.gridId,
      sortCriteria: this.sortCriteria,
      columns: this.columns,
      height: this.height,
      dynamicColumns: this.dynamicColumns
    };
  };
  return GridSettings;
};
GridSettingsFactory.$inject = ['GridColumnFactory', 'GridColumnGroupFactory', 'SortCriteriaFactory', 'SortColumnFactory', 'GridColumnAvailabilityService'];
module.exports = GridSettingsFactory;